import { RouteButton } from "@/components/Buttons";
import { openFolder } from "@/components/misc";
import { CiEdit } from "react-icons/ci";
import { FaCloud, FaRegClipboard, FaRegEnvelopeOpen, FaTasks, FaUpload } from "react-icons/fa";

export function UpdateProjectButton({project_id}: {project_id: string}) {
    return (
        <RouteButton route={"/projects/update_project/" + project_id} text="Edit" icon={<CiEdit />} />
    )
}

export function AssignTasksButton({project_id}: {project_id: string}) {
    return (
        <RouteButton route={"/tasks/assign_tasks/" + project_id} text="Assign Tasks" icon={<FaTasks />} />
    )
}

export function CreateSubmittalButton({project_id}: {project_id: string}) {
    return (
        <RouteButton route={"/submittals/create_submittal_from_project/" + project_id} text="Create Submittal" icon={<FaRegClipboard />} />
    )
}

export function CreateRFIButton({project_id}: {project_id: string}) {
    return (
        <RouteButton route={"/rfi/create_rfi_from_project/" + project_id} text="Create RFI" icon={<FaRegEnvelopeOpen />} />
    )
}

export function UploadDocumentButton({project_id, folder_location}: {project_id: string, folder_location: string}) {
    return (
        <RouteButton route={"/projects/upload_file/" + project_id} text="Upload Documents" onClick={() => openFolder((folder_location ?? "") + "/pdfs")} icon={<FaUpload />} />
    )
}

export function UploadProposalButton({project_id, folder_location}: {project_id: string, folder_location: string}) {
    return (
        <RouteButton route={"/projects/upload_proposal/" + project_id} text="Upload Proposal" onClick={() => openFolder((folder_location ?? "") + "/proposals")} icon={<FaUpload />} />
    )
}

export function CVDocumentsButton({project_id}: {project_id: string}) {
    return (
        <RouteButton route={`/cv/${project_id}/documents`} text="View Documents List" icon={<FaCloud />} />
    )
}

export function CVProposalsButton({project_id}: {project_id: string}) {
    return (
        <RouteButton route={`/cv/${project_id}/proposals`} text="View Proposals List" icon={<FaCloud />} />
    )
}